export default "__VITE_ASSET__BsL$HopW__"